import { availabilityScoreOverrideControl } from '../access-control/searchAccess.configuration.ts'
import { useDomainAccessControl } from './domain/accessControl'

const TEST_RETAILER = '1000' // The Garden

export const useHasAvailabilityScoreOverride = (retailerId: string) => {
  const hasAccess = useDomainAccessControl()
  return hasAccess(availabilityScoreOverrideControl) || retailerId == TEST_RETAILER
}
